window.MF = window.MF || {};

var WindowHelper = window.MF.WindowHelper;
var TextHelper = window.MF.TextHelper;
var EmailHelper = window.MF.EmailHelper;

window.MF.SocialAPI = function () {
  return {
    shareToFacebook: function (url, name, description, mindflashLogoURL, companyLogoURL) {
      var resultUrl = "https://www.facebook.com/sharer.php?s=100&p[title]=" + encodeURIComponent(name)
      + "&p[summary]=" + encodeURIComponent(TextHelper.truncateText(description, 250) + decodeURIComponent('%0D%0A')+ "Powered by Mindflash.")
      + "&p[url]=" + encodeURIComponent(url);

      if (companyLogoURL){
        resultUrl = resultUrl + "&p[images][0]=" + encodeURIComponent(companyLogoURL);
      }
      else {
        resultUrl = resultUrl + "&p[images][0]=" + encodeURIComponent(mindflashLogoURL);
      }

      WindowHelper.popup(resultUrl);
    },

    shareToLinkedIn: function (url, name) {
      var resultUrl = "https://www.linkedin.com/shareArticle?mini=true"
          + "&url=" + encodeURIComponent(url)
          + "&title=" + encodeURIComponent(name);

      WindowHelper.popup(resultUrl);
    },

    shareToTwitter: function (url, text) {
      var resultUrl = "https://twitter.com/intent/tweet?url=" + encodeURIComponent(url)
        + "&text=" + encodeURIComponent(text);

      WindowHelper.popup(resultUrl);
    },

    shareByEmailPCP: function (url, title, description, company) {
      var subject = encodeURIComponent(TextHelper.truncateText("Online Course: " + title, 85));
      var body = encodeURIComponent("Hi,\r\n\r\nI found this great online course that might interest you.\r\n\r\n")
        + url + encodeURIComponent("\r\n\r\n" + title + "\r\n" + TextHelper.truncateText(description, 150)
        + "\r\n\r\nCreated by " + company + ", powered by Mindflash\r\n\r\nEnjoy!");

      EmailHelper.sendEmail(subject, body);
    },

    shareByEmail: function (url, title, description, company, trainerName, type) {
      if (!type) type = 'course';
      type = type.toLowerCase();
      var endGreetings = trainerName ?  ",\r\n" + trainerName : '';
      var titleCaseType = type.substr(0, 1).toUpperCase() + type.substr(1, type.length - 1);
      var subject = encodeURIComponent(TextHelper.truncateText("Online " + titleCaseType + ": " + title, 85));
      var body = encodeURIComponent("Hi,\r\n\r\nYou have been invited in the online " + type + ". Please click on the link below to begin.\r\n\r\n")
        + url + encodeURIComponent("\r\n\r\n" + title + "\r\n" + TextHelper.truncateText(description, 150)
        + "\r\n\r\nThanks" + endGreetings);

      EmailHelper.sendEmail(subject, body);
    }
  };
} ();
